module.exports = __webpack_public_path__ + "static/media/210옴니고딕030.e0d68499.ttf";